import { Component, signal } from '@angular/core';
import { Header } from '../../components/header/header';
import { Documents } from '../../views/documents/documents';
import { Index } from '../../views/index';
import { Sidebar } from '../../components/sidebar/sidebar';
import { WebSites } from '../../views/web-sites/web-sites';

// Definiamo i tipi possibili per la nostra navigazione
type ViewMode = 'index' | 'documents' | 'to-process' | 'processed' | 'error' | 'web-sites';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    Header, 
    Sidebar, 
    Index,
    Documents,
    WebSites
  ],
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home {
  // Il Signal che comanda quale componente mostrare
  currentView = signal<ViewMode>('index');

  // Metodo per cambiare la vista, richiamato dalla sidebar
  switchView(newView: string) {
    this.currentView.set(newView as ViewMode);
  }
}